module.exports = __webpack_public_path__ + "static/img/downArrow.bbfbf2e8.png";